import React from "react";
import type { MediaPack } from "components/characters/MediaPackCard/MediaPackCard";
import MediaPackCard from "components/characters/MediaPackCard/MediaPackCard";
import styled from "styled-components";

import magic_stick_icon from '../../../../assets/magic_stick_icon.svg';

interface IGalleryProps {
  mediaPacks: MediaPack[];
  hasPhotoGenerator: boolean;
  onCreatePhoto: () => void;
  game?: Record<string, unknown>;
  scenario?: Record<string, unknown>;
  characterName?: string;
  setIsSubscriptionModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsSignUpModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsEmailConfirmationModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const StyledMediaPackCard = styled(MediaPackCard)`
  height: 184px;
  min-height: 184px;
  max-height: 184px;
  @media (max-width: 720px) {
    height: auto;
    min-height: unset;
    max-height: 169px;
  }
`;

const Gallery: React.FC<IGalleryProps> = (props) => {
  const {
    mediaPacks = [],
    hasPhotoGenerator,
    onCreatePhoto,
    game,
    scenario,
    characterName,
    setIsSubscriptionModalOpen,
    setIsSignUpModalOpen,
    setIsEmailConfirmationModalOpen
  } = props;

  const availableMediaPacks = mediaPacks.filter((mediaPack) => !!mediaPack.isActive);
  const shouldLimitWidth = !hasPhotoGenerator && availableMediaPacks.length === 1;

  return (
    <GalleryWrapper>
      <GalleryTitle>Gallery</GalleryTitle>
      <GalleryGrid $shouldLimitWidth={shouldLimitWidth}>
        {hasPhotoGenerator && (
          <GeneratorPhotoModalGap onClick={onCreatePhoto}>
            <img src={magic_stick_icon} alt="Create" />
            Create your<br />Own Photo
          </GeneratorPhotoModalGap>
        )}
        {availableMediaPacks.map((mediaPack) => (
          <StyledMediaPackCard
            key={mediaPack.id || mediaPack._id}
            mediaPack={mediaPack}
            setIsSubscriptionModalOpen={setIsSubscriptionModalOpen}
            setIsSignUpModalOpen={setIsSignUpModalOpen}
            setIsEmailConfirmationModalOpen={setIsEmailConfirmationModalOpen}
            game={game}
            scenario={scenario}
            characterName={characterName}
          />
        ))}
      </GalleryGrid>
    </GalleryWrapper>
  );
};

export default Gallery;

const GalleryWrapper = styled.div`
  background-color: transparent;
  border-radius: 12px;

  @media (max-width: 720px) {
    margin-bottom: 30px;
    padding: 0px 24px;
  }
`;

const GalleryTitle = styled.h3`
  font-family: Raleway;
  font-weight: 700;
  font-size: 40px;
  line-height: 42px;
  padding-bottom: 20px;
  color: #fff;

  @media (max-width: 720px) {
    font-size: 20px;
    line-height: 22px;
  }
`;

const GalleryGrid = styled.div<{ $shouldLimitWidth?: boolean }>`
  display: grid;
  grid-template-columns: ${props => props.$shouldLimitWidth ? '410px' : 'repeat(auto-fit, minmax(290px, 1fr))'};
  gap: 24px;
  justify-content: ${props => props.$shouldLimitWidth ? 'start' : 'normal'};

  @media (max-width: 720px) {
    gap: 16px;
    grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
    justify-content: normal;
  }
`;

const GeneratorPhotoModalGap = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: rgba(70, 55, 50, 1);
  border-radius: 20px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='20' ry='20' stroke='%23FF7E55FF' stroke-width='2' stroke-dasharray='12%2c 16' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  font-family: Raleway;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
  min-height: 184px;
  max-height: 184px;
  padding: 46px 32px;
  @media (max-width: 720px) {
    max-height: 169px;
    border-radius: 12px;
    padding: 24px 32px;
  }
`;
